/* eslint-disable security/detect-non-literal-regexp */
// NOTE: "target" is not the best name, consider something that
// communicates "secondary thing in operation, where first thing is user account"
// in a way any financial operation is exchange between two places, target is the second one
// terms "sender" and "receiver" could potentially fit but some operations must
// visually place receiver in the first place and we need a way to know when to do it
import {literalUnion} from '@raison/io-ts-tools';
import {EntityId} from '@reduxjs/toolkit';
import {TypeOf} from 'io-ts';

export type TargetType = TypeOf<typeof TargetType>;
export const TargetType = literalUnion('card', 'bank', 'fiat', 'crypto', 'stablecoin', 'wallet');

const targetIdTypes = Object.keys(TargetType.keys);
const validTargetId = new RegExp(`(${targetIdTypes.join('|')}):(.+)`);

export type TargetId = string & {
    [key in {readonly TargetId: unique symbol}['TargetId']]: never;
};
export const TargetId = {
    from(id: EntityId, type: TargetType) {
        return `${type}:${id}` as TargetId;
    },
    getJustId(this: void, typedId: TargetId): string | number {
        const [_, _type, id] = new RegExp(validTargetId, 'g').exec(typedId)!;
        if (id.match(/^\d+$/)) {
            return Number(id);
        }
        return id;
    },
    getJustType(this: void, typedId: TargetId): TargetType {
        const [_, type] = new RegExp(validTargetId, 'g').exec(typedId)!;
        return type as TargetType;
    },
};

export type TargetStatus = TypeOf<typeof TargetStatus>;
export const TargetStatus = literalUnion('verified', 'not_verified', 'pending');
